import React, { useMemo } from 'react';
import { MetricsData } from '../../../services/network/form30SectorCharts-api';
import styles from './MetricsBlock.module.css';

interface MetricsBlockProps {
    data: MetricsData | null;
    selectedBlock: number | null; // 0 - первый блок, 1 - второй блок, null - ни один не выбран
    onBlockClick: (blockIndex: number) => void;
}

export const MetricsBlock: React.FC<MetricsBlockProps> = ({ data, selectedBlock, onBlockClick }) => {
    // Вычисляем значения метрик
    const metrics = useMemo(() => {
        const calculatePercentage = (x: number | null, y: number | null): string => {
            if (x === null || y === null || y === 0) return '—';
            const result = (x / y) * 100;
            return result.toFixed(1) + '%';
        };

        // Если данных нет, возвращаем метрики с прочерками
        if (!data) {
            return [
                { label: 'Охват ПО все дети', value: '—' },
                { label: 'Охват ПО дети-инвалиды', value: '—' },
                { label: 'Доля детей с выявл. забол.', value: '—' },
                { label: 'Доля детей с выявл. забол. впервые', value: '—' },
            ];
        }

        return [
            {
                label: 'Охват ПО все дети',
                value: calculatePercentage(data.all_children_fact, data.all_children_plan),
            },
            {
                label: 'Охват ПО дети-инвалиды',
                value: calculatePercentage(data.disabled_children_fact, data.disabled_children_plan),
            },
            {
                label: 'Доля детей с выявл. забол.',
                value: calculatePercentage(data.diseases_total, data.all_children_fact),
            },
            {
                label: 'Доля детей с выявл. забол. впервые',
                value: calculatePercentage(data.diseases_first, data.all_children_fact),
            },
        ];
    }, [data]);

    const handleBlockClick = (blockIndex: number) => {
        // Если кликнули на уже выбранный блок - отжимаем его
        if (selectedBlock === blockIndex) {
            onBlockClick(-1); // -1 означает что ни один блок не выбран
        } else {
            onBlockClick(blockIndex);
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.metricsWrapper}>
                {/* Первый блок (метрики 0 и 1) */}
                <div 
                    className={`${styles.block} ${styles.leftBlock} ${selectedBlock === 0 ? styles.activeBlock : ''}`}
                    onClick={() => handleBlockClick(0)}
                >
                    {metrics.slice(0, 2).map((metric, idx) => (
                        <div key={idx} className={styles.metricItem}>
                            <div className={styles.metricLabel}>{metric.label}</div>
                            <div className={styles.metricValue}>{metric.value}</div>
                        </div>
                    ))}
                </div>

                {/* Второй блок (метрики 2 и 3) */}
                <div 
                    className={`${styles.block} ${styles.rightBlock} ${selectedBlock === 1 ? styles.activeBlock : ''}`}
                    onClick={() => handleBlockClick(1)}
                >
                    {metrics.slice(2, 4).map((metric, idx) => (
                        <div key={idx} className={styles.metricItem}>
                            <div className={styles.metricLabel}>{metric.label}</div>
                            <div className={styles.metricValue}>{metric.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
